"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var react_apollo_1 = require("react-apollo");
var offer_operations_1 = require("./offer_operations");
var offer_listing_seller_cost_1 = require("./offer_listing_seller_cost");
var EMPTY_CELL_TEXT = '--';
function renderImage(listing) {
    var imageUrl = lodash_1.get(lodash_1.head(listing.images), 'source');
    if (imageUrl) {
        return (React.createElement("img", { src: imageUrl, alt: listing.title }));
    }
    return null;
}
function OfferListingSidebar(_a) {
    var listing = _a.listing, isSeller = _a.isSeller, isLoading = _a.isLoading, listingUrlGenerator = _a.listingUrlGenerator;
    if (isLoading) {
        return (React.createElement("div", { className: "modal-sidebar-listing modal-sidebar-listing--loading" },
            React.createElement("div", { className: "modal-sidebar-listing__thumbnail" }),
            React.createElement("div", { className: "modal-sidebar-listing__title" }),
            React.createElement("div", { className: "modal-sidebar-listing__details-label" }),
            React.createElement("div", { className: "modal-sidebar-listing__details" }),
            React.createElement("div", { className: "modal-sidebar-listing__link" })));
    }
    var displayPrice = isSeller ? lodash_1.get(listing, 'sellerPrice.display') : lodash_1.get(listing, 'price.display');
    var condition = lodash_1.get(listing, 'condition.displayName');
    return (React.createElement("div", { className: "modal-sidebar-listing" },
        React.createElement("div", { className: "modal-sidebar-listing__thumbnail" }, renderImage(listing)),
        React.createElement("h2", { className: "modal-sidebar-listing__title" }, listing.title),
        React.createElement("dl", { className: "modal-sidebar-listing__details" },
            condition &&
                React.createElement("div", { className: "modal-sidebar-listing__detail" },
                    React.createElement("dt", null, I18n.t('commons.offers.sidebar.condition')),
                    React.createElement("dd", null, condition)),
            React.createElement("div", { className: "modal-sidebar-listing__detail" },
                React.createElement("dt", null, I18n.t('commons.offers.sidebar.askingPrice')),
                React.createElement("dd", null, displayPrice)),
            React.createElement("div", { className: "modal-sidebar-listing__detail" },
                React.createElement("dt", null, I18n.t('commons.offers.sidebar.shopDisplayLocation')),
                React.createElement("dd", null, lodash_1.get(listing, 'shop.address.displayLocation', EMPTY_CELL_TEXT))),
            isSeller &&
                React.createElement(offer_listing_seller_cost_1.default, { sellerCostDisplay: lodash_1.get(listing, 'sellerCost.display') })),
        listingUrlGenerator &&
            React.createElement("a", { href: listingUrlGenerator(listing.id), className: "modal-sidebar-listing__link", target: "_blank", rel: "noopener noreferrer" }, I18n.t('commons.offers.sidebar.viewListing'))));
}
exports.OfferListingSidebar = OfferListingSidebar;
exports.ConnectedOfferListingSidebar = react_apollo_1.compose(offer_operations_1.connectCreateOfferFormQuery)(function (props) {
    if (!props.isDisplayed) {
        return null;
    }
    return (React.createElement(OfferListingSidebar, tslib_1.__assign({}, props, { isLoading: lodash_1.get(props, 'data.loading'), listing: lodash_1.get(props, 'data.listing') })));
});
//# sourceMappingURL=offer_listing_sidebar.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/offers/offer_listing_sidebar.js
// module id = NvZs
// module chunks = 20 21